import React, { useReducer } from 'react';
import HistoricoContext from './historicoContext';
import historicoReducer from './historicoReducer';
import { WidType } from "types/widget"

import clienteAxios from '../../service/axios';

import {
    OBTENER_HISTORICO,
    HISTORICO_ERROR,
    HISTORICO_OK,
    START_LOADING,
    STOP_LOADING,
    SELECCIONAR_GRAFICO,
    FILTRO_FECHA
} from 'types/context';

const HistoricoState = props => {
    const initialState = {
        historico: [],
        mensaje: null,
        loading: false,
        textoFiltroFecha: "",
        graficoElegido: WidType.Barras
    }

    const [state, dispatch] = useReducer(historicoReducer, initialState);
    const obtenerHistorico = async (id, fechaDesde, fechaHasta) => {

        let resultado;
        try {
            dispatch({
                type: START_LOADING
            })

            if (fechaDesde && fechaHasta){
                resultado = await clienteAxios.get(`/historico/${id}`, 
                {
                    params: {
                        fechaDesde: fechaDesde,
                        fechaHasta: fechaHasta,
                    },
                  } 
               ); 
            } else {
                resultado = await clienteAxios.get(`/historico/${id}`);
            }

            dispatch({
                type: OBTENER_HISTORICO,
                payload: resultado.data.variables || []
            });

            dispatch({
                type: FILTRO_FECHA,
                payload: {
                    fechaDesde: fechaDesde,
                    fechaHasta: fechaHasta
                }
            })

            dispatch({
                type: STOP_LOADING
            })

            return resultado.data.variables || []
        } catch (error) {
            dispatch({
                type: OBTENER_HISTORICO,
                payload: null
            });

            dispatch({
                type: STOP_LOADING
            })
            
            const alerta = {
                msg: "error.response.data.message",
                categoria: 'error'
            }
            
            dispatch({
                type: HISTORICO_ERROR,
                payload: alerta
            })
            return  []
        }
    }

    const seleccionarGrafico = (grafico) => {
        if ( grafico !== null ) {
            dispatch({
                type: SELECCIONAR_GRAFICO,
                payload: grafico
            })
        }
    }

    // muestra un error de validacion
    const errorHistorico = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: HISTORICO_ERROR,
            payload: alerta
        })
    }
    const OkHistorico = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: HISTORICO_OK,
            payload: alerta
        })
    }
    const clearErrorHistorico = () => {
        dispatch({
            type: HISTORICO_ERROR,
            payload: null,
        });
    };

    const clearOkHistorico = () => {
        dispatch({
            type: HISTORICO_OK,
            payload: null,
        });
    };


    return (
        <HistoricoContext.Provider
            value={{
                loading: state.loading,
                historico: state.historico,
                mensaje: state.mensaje,
                graficoElegido: state.graficoElegido,
                textoFiltroFecha: state.textoFiltroFecha,
                seleccionarGrafico,
                obtenerHistorico,
                clearErrorHistorico,
                clearOkHistorico,
                errorHistorico,
                OkHistorico,
            }}
        >{props.children}

        </HistoricoContext.Provider>
    )
}
export default HistoricoState;